module.exports = __webpack_public_path__ + "assets/img/pike.09b95771.png";